// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const ImmutableToJS = require('client-v2/common/components/immutable-to-js')
const deferDispatch = require('client-v2/common/state/dispatch')
// Container imports
const profileUserActions = require('../profile-user/actions')
const UserProfileSocialNav = require('./component-dumb')

function mapStateToProps(state) {
  const {
    profileUser,
    profileUserStats
  } = state
  return {
    isSelfProfile: profileUser.id === state.user.id,
    selected: selectedState(state),
    profileUser,
    profileUserStats
  }
}

function mapDispatchToProps(dispatch) {
  const { dispatchAction } = deferDispatch(dispatch)
  return {
    onFollowersClick: dispatchAction(profileUserActions.navigateToUserProfileFollowers),
    onFollowingClick: dispatchAction(profileUserActions.navigateToUserProfileFollowing)
  }
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  ImmutableToJS(
    UserProfileSocialNav
  )
)

function selectedState(state) {
  switch (state.router.action) {
    case 'user-profile.showFollowers':
      return 'followers'
    case 'user-profile.showFriends':
      return 'following'
    default:
      return null
  }
}
